import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── MarketingIQ ───────────────────────────────────────────────────────────────────
// Persona: VP Marketing
// Data sources: See constants/modules.js

const KPIs = [
  { label: "MQLs (MTD)", value: "1,842", delta: "+14% MoM", color: "#059669" },
  { label: "MQL→SQL Rate", value: "34%", delta: "+4pts QoQ", color: "#059669" },
  { label: "CPL (blended)", value: "$182", delta: "-12% QoQ", color: "#059669" },
  { label: "Pipeline Gen", value: "$2.1M", delta: "Q2 total", color: "#059669" },
  { label: "Campaign ROI", value: "3.2x", delta: "Blended", color: "#059669" },
  { label: "Organic MQL %", value: "62%", delta: "+8pts YoY", color: "#059669" }
];
const CHART_DATA = [
  {
    "channel": "Organic SEO",
    "mqls": 680,
    "cpl": 42
  },
  {
    "channel": "Paid Search",
    "mqls": 420,
    "cpl": 210
  },
  {
    "channel": "Content",
    "mqls": 380,
    "cpl": 68
  },
  {
    "channel": "Events",
    "mqls": 210,
    "cpl": 340
  },
  {
    "channel": "Paid Social",
    "mqls": 152,
    "cpl": 290
  }
];

export default function MarketingIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>MQLs by Channel</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="channel" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Bar dataKey="mqls" fill="#db2777" radius={[4,4,0,0]} />
          <Bar dataKey="cpl" fill="#f472b6" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Organic SEO delivers 37% of MQLs at $42 CPL vs $210 for paid search — content investment has a 5x efficiency advantage.</p>
        </div>
      </div>
    </div>
  );
}
